module.exports = __webpack_public_path__ + "img/discount-amount-icon.15f1857d.svg";